import request from '@/utils/request'
import base from "@/api/base";

export default {
  // 登录接口
  login: (params, headers) => request.post(`${base.baseUrl}/yyyhao-cloud-auth/oauth2/token`, params, headers),
  //获取验证码
  yzm: params => request.get(`${base.baseUrl}/yyyhao-cloud-auth/auth/captcha`, { params }),
  //主菜单权限
  qx: params => request.get(`${base.baseUrl}/yyyhao-cloud-system/user/getUserParentMenu`, params),
  //子菜单权限
  ziqx: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/getUserChildMenuAndPermission`, params),
  //获取登录用户信息
  user: params => request.get(`${base.baseUrl}/yyyhao-cloud-system/user/me`, params),


  //获取抖音二维码登录
  logins: () => request.get(`${base.baseUrl}/yyyhao-cloud-auth/auth/platform/douyin`),
  //获取微信支付宝抖音扫码成功之后获取token
  getoken: (params, headers) => request.get(`${base.baseUrl}/yyyhao-cloud-auth/auth/getTokenByState/${params}`, headers),
  //获取前台用户信息
  qtuser: () => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/me`),

  //获取微信二维码登录
  wxlogin: () => request.get(`${base.baseUrl}/yyyhao-cloud-auth/auth/platform/wechat`),
  //前台账号密码登录
  pass: (params, headers) => request.post(`${base.baseUrl}/yyyhao-cloud-auth/oauth2/token`, params, headers),

  //绑定平台
  bdpt: params => request.post(`${base.baseUrl}/yyyhao-cloud-auth/auth/bindPlatform`, params),
  //解绑平台
  del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/unbindPlatform`, params),
  //获取绑定状态
  get: params => request.get(`${base.baseUrl}/yyyhao-cloud-auth/auth/getBindInfoByState/${params}`, params),
  //设置手机号
  updata: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/updateSelfInfo`, params),
  //修改密码
  uppass: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/updatePassword`, params),
}


